import { IAccountInfo, MEMBER_TYPE } from '../../../interface/account';
import { ISearchItem } from '../../../../searchInput';
import { INavInfo } from '../../../interface/index';
import { openWindow } from '@umu/umu-dom';
import { PERMISSION_CONTENT_TYPE } from '../interface';
import { getSessionInfo } from '../../../server';

const onEditorPermission = (navInfo: INavInfo) => {
    const { related_content_id: id = '0', related_type } = navInfo;
    if (!id) {
        return;
    }
    switch (String(related_type)) {
        case PERMISSION_CONTENT_TYPE.SESSION:
            getSessionInfo({
                session_id: id,
            }).then((res: any) => {
                res?.groupId && openWindow(`/course/index#/groups/${res?.groupId}/sessions/${id}/view`, '_blank');
            });
            break;
        case PERMISSION_CONTENT_TYPE.COURSE:
            openWindow(`/course/index#/groups/${id}/groupInfo/view`, '_blank');
            break;
        case PERMISSION_CONTENT_TYPE.PROGRAM:
            openWindow(`/program/index#/programs/${id}/modules`, '_blank');
            break;
        case PERMISSION_CONTENT_TYPE.MICRO_PAGES:
            openWindow(`/platformManage/index#/microPages`, '_blank');
            break;
        default:
            break;
    }
};
const onTransformParams = (addList: ISearchItem[], closeList: IAccountInfo[]) => {
    const list = addList.map((item) => {
        const info = item.info;
        const accountType = info?.type || info?.account_type || MEMBER_TYPE.USER;
        const isUser = accountType === MEMBER_TYPE.USER;
        return {
            account: info?.account,
            account_type: accountType,
            type: 1,
            id: info?.id,
            [isUser ? 'umu_id' : 'department_id']: info?.id,
        };
    });
    if (closeList.length > 0) {
        closeList.forEach((item) => {
            const accountType = item.account_type;
            const isUser = accountType === MEMBER_TYPE.USER;
            list.push({
                account: item.account,
                account_type: item.account_type,
                type: 2,
                id: item.id,
                [isUser ? 'umu_id' : 'department_id']: item?.id,
            });
        });
    }
    return list;
};
export { onTransformParams, onEditorPermission };
